"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Col = exports.Row = exports.Grid = void 0;

var _styledBootstrapGrid = require("styled-bootstrap-grid");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Outer wrapper when using a grid
 * @deprecated Use `<GridColumns>`
 */
var Grid = (0, _styledComponents.default)(_styledBootstrapGrid.Container).withConfig({
  displayName: "Grid",
  componentId: "etz25q-0"
})(["max-width:", "px;", ";"], function (props) {
  return props.theme.grid.breakpoints.xl;
}, (0, _styledSystem.compose)(_styledSystem.space, _styledSystem.maxWidth, _styledSystem.border));
/**
 * Grid row
 * @deprecated
 */

exports.Grid = Grid;
var Row = (0, _styledComponents.default)(_styledBootstrapGrid.Row).withConfig({
  displayName: "Grid__Row",
  componentId: "etz25q-1"
})(["", ";"], (0, _styledSystem.compose)(_styledSystem.color, _styledSystem.space));
/**
 * Grid column
 * @deprecated
 */

exports.Row = Row;
var Col = (0, _styledComponents.default)(_styledBootstrapGrid.Col).withConfig({
  displayName: "Grid__Col",
  componentId: "etz25q-2"
})(["", ""], (0, _styledSystem.compose)(_styledSystem.color, _styledSystem.flex, _styledSystem.space, _styledSystem.textAlign, _styledSystem.width));
exports.Col = Col;
Grid.displayName = "Grid";
Row.displayName = "Row";
Col.displayName = "Col";
//# sourceMappingURL=Grid.js.map